import { render, staticRenderFns } from "./transaction-mail-setting.vue?vue&type=template&id=73c99ecc"
import script from "./transaction-mail-setting.vue?vue&type=script&lang=js"
export * from "./transaction-mail-setting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports